import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _INFRASTRUCTURE_TYPE_;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ca } from '@cian/analytics';
import { InfrastructureType } from '../../types/mvk_state';
import { getTrackingCategory } from '../helpers';
export var INFRASTRUCTURE_TYPE_MAP = (_INFRASTRUCTURE_TYPE_ = {}, _defineProperty(_INFRASTRUCTURE_TYPE_, InfrastructureType.Schools, 'schools'), _defineProperty(_INFRASTRUCTURE_TYPE_, InfrastructureType.Kindergarden, 'kindergatens'), _defineProperty(_INFRASTRUCTURE_TYPE_, InfrastructureType.Polyclinics, 'polyclinics'), _defineProperty(_INFRASTRUCTURE_TYPE_, InfrastructureType.GroceryStores, 'shops'), _defineProperty(_INFRASTRUCTURE_TYPE_, InfrastructureType.Cafes, 'cafes'), _INFRASTRUCTURE_TYPE_);

// Клик на секцию корпуса
export var trackSectionClick = function trackSectionClick(isOfferCard) {
  ca('eventSite', {
    action: 'master_podbora_click',
    category: getTrackingCategory(isOfferCard),
    label: 'section',
    name: 'oldevent',
    useLastProducts: true
  });
};

// Изменение фильтра этажности
export var trackFloorFilterChange = function trackFloorFilterChange(isOfferCard) {
  ca('eventSite', {
    action: 'master_podbora_click',
    category: getTrackingCategory(isOfferCard),
    label: 'floor',
    name: 'oldevent',
    useLastProducts: true
  });
};

// Изменение фильтра комнатности
export var trackRoomFilterChange = function trackRoomFilterChange(isOfferCard) {
  ca('eventSite', {
    action: 'master_podbora_click',
    category: getTrackingCategory(isOfferCard),
    label: 'room_qty',
    name: 'oldevent',
    useLastProducts: true
  });
};

// Клик по комнате в поэтажном плане
export var trackFlatInFloorPlanClick = function trackFlatInFloorPlanClick(isOfferCard) {
  ca('eventSite', {
    action: 'master_podbora_click',
    category: getTrackingCategory(isOfferCard),
    label: 'flat',
    name: 'oldevent',
    useLastProducts: true
  });
};

// Раскрытие списка инфраструктуры на карте
export var trackInfrastructureShow = function trackInfrastructureShow(isOfferCard) {
  ca('eventSite', {
    action: 'infrastructure_show',
    category: getTrackingCategory(isOfferCard),
    label: '',
    name: 'oldevent',
    useLastProducts: true
  });
};

// Выбор типа инфраструктуры на карте
export var trackInfrastructureChange = function trackInfrastructureChange(type, isOfferCard) {
  ca('eventSite', {
    action: 'infrastructure_click',
    category: getTrackingCategory(isOfferCard),
    label: INFRASTRUCTURE_TYPE_MAP[type] || '',
    name: 'oldevent',
    useLastProducts: true
  });
};

// Клик на "Предложения рядом" в сайдбаре
export var trackSimilarSuggestionsClick = function trackSimilarSuggestionsClick(isOfferCard) {
  ca('eventSite', {
    action: 'go_to_similar_on_map',
    category: getTrackingCategory(isOfferCard),
    label: '',
    name: 'oldevent',
    useLastProducts: true
  });
};

// Нажатие на избранное в квартире
export var trackFlatFavoriteButtonClick = function trackFlatFavoriteButtonClick(hasAddedToFavorites, customUrl) {
  ca('eventSite', {
    action: hasAddedToFavorites ? 'add_master_podbora' : 'remove_master_podbora',
    category: 'favorite',
    label: customUrl,
    name: 'oldevent',
    useLastProducts: true
  });
};

// Клик на похожую квартиру
export var trackSimilarFlatClick = function trackSimilarFlatClick(customUrl) {
  ca('eventSite', {
    action: 'click_similar_master_podbora',
    category: 'similar_objects',
    label: customUrl,
    name: 'oldevent',
    useLastProducts: true
  });
};

// Расхлоп телефона на уровне квартиры
export var trackPhoneButtonClick = function trackPhoneButtonClick(analyticsData, isOfferCard) {
  if (!analyticsData) {
    return;
  }
  var product = _objectSpread(_objectSpread({}, analyticsData), {}, {
    customUrl: undefined
  });
  ca('eventSite', {
    action: isOfferCard ? 'Open_card_master_podbora' : 'Open_jk_card_master_podbora',
    category: 'Phones',
    label: analyticsData.customUrl,
    name: 'oldevent',
    products: [product]
  });
};